// extracted by mini-css-extract-plugin
export default {"numbers":"performance-element_numbers__Diqyp","performance":"performance-element_performance__ZJ2b9"};